package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kosmos.ui.layouts.card
import dev.fritz2.core.RenderContext

fun RenderContext.noPartnerDataFoundMessage(
    message: String = "Es wurden keine Partnerdaten gefunden.",
    actionContent: RenderContext.() -> Unit = {}
) {
    card {
        paragraph {
            +message
        }
        actionContent()
    }
}

fun RenderContext.noContractDataFoundMessage(
    message: String = "Es wurden keine Vertragsdaten gefunden.",
    actionContent: RenderContext.() -> Unit = {}
) {
    card {
        paragraph {
            +message
        }
        actionContent()
    }
}